import React, {useEffect, useState} from 'react';
import {renderRoutes} from "react-router-config";
import {BrowserRouter} from "react-router-dom";
import routes from "./routes";
import {ConfigProvider} from "antd";
import enUS from "antd/lib/locale/en_US";
import {authenticatedUserSubject, getUserMe, useUserMe} from "./hooks/user";
import {Auth} from "aws-amplify";

function App() {

    const [init, setInit] = useState(false);
    const userMeResponse = useUserMe();
    useEffect(() => {
        Auth.currentAuthenticatedUser().then(user => {
            authenticatedUserSubject.next(user);
            getUserMe();
        }).catch(console.error).finally(() => {
            setInit(true);
        });
    }, [true]);

    return (
        <ConfigProvider locale={enUS}>
            <BrowserRouter>
                <div className="App">
                    {!!init && !userMeResponse.loading && renderRoutes(routes)}
                </div>
            </BrowserRouter>
        </ConfigProvider>
    );
}

export default App;
